import _regeneratorRuntime from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import { mapState } from "vuex";
import { getData } from "@/services/axios";
import { dragscroll } from "vue-dragscroll";
import { dashboardTableList } from "@/consts/dashboardTableList";
var __default__ = {
  name: "AllClassAbsenceCounter",
  filters: {
    zeroFallback: function zeroFallback(val) {
      return val ? val : 0;
    }
  },
  directives: {
    dragscroll: dragscroll
  },
  data: function data() {
    return {
      dashboardTableList: dashboardTableList,
      isLoading: true,
      absenceByClassroom: []
    };
  },
  computed: _objectSpread({}, mapState(["school", "grades"])),
  created: function created() {
    var _this = this;

    this.setData();
    this.intervalId = setInterval(function () {
      _this.getAttendanceSummary();
    }, 1000 * 60);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    decimalAlignmentPercent: function decimalAlignmentPercent(count, studentsCount) {
      return count ? "(" + Math.round(count / studentsCount * 1000) / 10 + "%)" : "";
    },
    setData: function setData() {
      this.getAttendanceSummary();
    },
    getAttendanceSummary: function () {
      var _getAttendanceSummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, summaries, classroomList, schoolTotalAbsence;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getData("attendance_summaries_classrooms?dashboard=1");

              case 2:
                data = _context.sent;
                summaries = data.items;
                classroomList = this.classrooms.map(function (v) {
                  var _v = Object.assign({}, v);

                  _v["absence"] = summaries[v.id] ? summaries[v.id] : {};
                  return _v;
                }); // 全校のabsenceの計算

                schoolTotalAbsence = classroomList.reduce(function (absence, v) {
                  Object.keys(v["absence"]).forEach(function (key) {
                    if (key in absence) {
                      absence[key] += v["absence"][key];
                    } else {
                      absence[key] = v["absence"][key];
                    }
                  });
                  return absence;
                }, {});
                this.absenceByClassroom = [{
                  name: "全校",
                  students_count: this.totalStudentCount,
                  absence: schoolTotalAbsence
                }].concat(_toConsumableArray(classroomList));
                this.isLoading = false;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAttendanceSummary() {
        return _getAttendanceSummary.apply(this, arguments);
      }

      return getAttendanceSummary;
    }()
  }
};
import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;

    var _storeToRefs = storeToRefs(useGradeClassroomStore()),
        classrooms = _storeToRefs.classrooms,
        totalStudentCount = _storeToRefs.totalStudentCount;

    expose({
      classrooms: classrooms,
      totalStudentCount: totalStudentCount
    });
    return {
      __sfc: true,
      classrooms: classrooms,
      totalStudentCount: totalStudentCount,
      dashboardTableList: dashboardTableList
    };
  }
});